import { ReactNode } from 'react'
import Navigation from './Navigation'
import styles from './AppLayout.module.css'

interface AppLayoutProps {
  children: ReactNode
}

function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.logo}>Self Motivation</h1>
      </header>

      <main className={styles.main}>{children}</main>

      <Navigation />
    </div>
  )
}

export default AppLayout
